export default __webpack_public_path__ + "static/media/qr-code-button.76d4cf9d.svg";